import type { RouteLocationNormalized } from 'vue-router';
import { normalizeScrollPosition } from '@/router/router-scroll.ts';

type ScrollRoute = Pick<RouteLocationNormalized, 'fullPath' | 'path'>;
type ScrollPosition = { left: number; top: number };

export function isBusinessSettingsRoute(route: ScrollRoute) {
  return route.path.startsWith('/settings/business/');
}

export function createBusinessSettingsScrollMemory() {
  const positions = new Map<string, ScrollPosition>();

  return {
    remember(route: ScrollRoute, position: ScrollPosition) {
      if (!isBusinessSettingsRoute(route)) return;
      positions.set(route.fullPath, {
        left: Math.max(0, position.left),
        top: Math.max(0, position.top),
      });
    },
    resolve(route: ScrollRoute, savedPosition: ScrollPosition | null): ScrollPosition | undefined {
      if (!isBusinessSettingsRoute(route)) return;
      return normalizeScrollPosition(savedPosition) ?? positions.get(route.fullPath) ?? { left: 0, top: 0 };
    },
  };
}
